import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TransactionStatus } from 'src/app/interfaces/transaction-status';

import { InvoiceForm } from './invoice-form';

export class TransactionForm extends FormGroup<{
  id: FormControl<number | undefined>;
  PaymentProviderId: FormControl<number | null>;
  InvoiceId: FormControl<number | undefined>;
  transType: FormControl<'CREDIT' | 'DEBIT' | undefined>;
  transMethod: FormControl<'ONLINE' | 'CASH' | 'CHECK' | undefined>;
  amount: FormControl<number | undefined>;
  status: FormControl<TransactionStatus | undefined>;
  refNumber: FormControl<string | undefined>;
  Invoice: InvoiceForm;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined, { nonNullable: true }),
      PaymentProviderId: new FormControl<number | null>(null, {
        validators: [Validators.required]
      }),
      InvoiceId: new FormControl<number | undefined>(undefined, {
        nonNullable: true
      }),
      transType: new FormControl<'CREDIT' | 'DEBIT' | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      transMethod: new FormControl<'ONLINE' | 'CASH' | 'CHECK' | undefined>(
        undefined,
        { nonNullable: true, validators: [Validators.required] }
      ),
      amount: new FormControl<number | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      refNumber: new FormControl<string | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      status: new FormControl<TransactionStatus | undefined>(undefined, {
        nonNullable: true
      }),

      Invoice: new InvoiceForm()
    });
  }
}

// Invoice?: Invoice;
// PaymentProvider?: PaymentProvider;
